import { Layout, Result } from 'antd';
import { Alert, Card, Col, Row } from 'antd';

import React, { } from 'react';
import { createUseStyles } from 'react-jss';


const useStyles = createUseStyles({
	block: {
		'& .buttons': {
			marginBottom: "10px"
		},
	},
	ticket: {
		padding: "5px 10px",
		display: "flex",
		cursor: "pointer",
		'&:hover': {
			backgroundColor: "#f9f9f9"
		}
	},
	ticketHeader: {
	},
	ticketName: {

	},
	collapsePanel: {
		'& .ant-collapse-content > .ant-collapse-content-box': {
			padding: "6px"
		},
		'&.ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box': {
			paddingTop: "0px",
			paddingBottom: "0px"
		}
	}
})

export default function SiteAccessDeny(props) {
	const classes = useStyles();

	return (
		<div style={{ backgroundColor: "white", borderRadius:"4px" }}>
            <div style={{ padding:  "10px" }}>
					<Result
						status="403"
						title="Выполняются технические работы"
						subTitle="В ближайшее время доступ будет восстановлен"
					/>
				</div>
				</div>
	);
}
